import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import * as React from "react"
import {
  carConfigs,
  VEHICLE_TYPE_NAMES,
  type VehicleType,
} from "@/lib/vehiclePresets"

export { carConfigs, VEHICLE_TYPE_NAMES, type VehicleType }

export default function VehicleTypeSelect({
  value,
  onValueChange,
  disabled = false,
  placeholder,
}: {
  value: VehicleType | undefined
  onValueChange: (vehicle: VehicleType) => void
  disabled?: boolean
  placeholder?: string
}) {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className="h-9 w-auto min-w-20 rounded-md border bg-background px-4 py-2 pr-2 font-medium hover:bg-blue-100 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-background dark:hover:bg-blue-800">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>

      <SelectContent>
        <SelectGroup>
          <SelectItem value="solo">Solo 18t</SelectItem>
          <SelectItem value="solo72">Solo 7.2t</SelectItem>
          <SelectItem value="bus">Bus</SelectItem>
          <SelectItem value="tir">TIR</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
